/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Role_SdInputs */

const en_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software Developer`)
};

const ar_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطور برمجيات`)
};

const bn_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সফটওয়্যার ডেভেলপার`)
};

const de_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softwareentwickler`)
};

const es_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador de software`)
};

const fr_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur de logiciels`)
};

const pt_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor de software`)
};

const zh_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件开发人员`)
};

const tr_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılım Geliştiricisi`)
};

const ru_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик программного обеспечения`)
};

const pl_resume_role_sd = /** @type {(inputs: Resume_Role_SdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programista oprogramowania`)
};

/**
* | output |
* | --- |
* | "Software Developer" |
*
* @param {Resume_Role_SdInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_role_sd = /** @type {((inputs?: Resume_Role_SdInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Role_SdInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_role_sd(inputs)
	if (locale === "bn") return bn_resume_role_sd(inputs)
	if (locale === "de") return de_resume_role_sd(inputs)
	if (locale === "es") return es_resume_role_sd(inputs)
	if (locale === "fr") return fr_resume_role_sd(inputs)
	if (locale === "pt") return pt_resume_role_sd(inputs)
	if (locale === "zh") return zh_resume_role_sd(inputs)
	if (locale === "tr") return tr_resume_role_sd(inputs)
	if (locale === "ru") return ru_resume_role_sd(inputs)
	if (locale === "pl") return pl_resume_role_sd(inputs)
	return en_resume_role_sd(inputs)
});